 export const headerConfig = {
    title: 'Red',
    subTitle : 'Fin',
    options: ['Rent', 'Buy', 'Sell']
  }
  

  export const NavItems = [
    {label: 'Home', route: '/', id: 'home' },
    {label: 'Featured', route: '/featured', id: 'featured' },
    {label: 'Packages', route: '/packages', id: 'packages' },
    {label: 'Contact Us', route: '/contactUs', id: 'contactUs' }
    
  ]